import { render } from "./Prognostic.vue?vue&type=template&id=0b98e92a&scoped=true"
import script from "./Prognostic.vue?vue&type=script&lang=js"
export * from "./Prognostic.vue?vue&type=script&lang=js"

import "./Prognostic.vue?vue&type=style&index=0&id=0b98e92a&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b98e92a"]])

export default __exports__